// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `html,
body {
  margin: 0;
  padding: 0;
  height: 100%;
}

body {
  display: flex;
  align-items: stretch;
}

#root {
  display: flex;
  align-items: stretch;
  width: 100%;
}

#page {
  display: flex;
  width: 100%;
}

#content-wrapper {
  display: flex;
  flex-direction: column;
  align-items: stretch;
  width: 100%;
  height: auto;
}

#content {
  width: 100%;
  padding: 0px;
  height: calc(100% - 48px);
  /*margin: 0 20px ;*/
}

#footer {
  position: absolute;
  bottom: 0;
  width: 100%;
  /* height: 100px; */
  /* Height of the footer */
}

.swal2-container {
  z-index: 1460 !important;
}

body.swal2-height-auto {
  height: 100% !important;
}

#desktop-tabpanel {
  scrollbar-width: thin;
}

#mobile-tabpanel {
  scrollbar-width: thin;
}

#weather-chart {
  scrollbar-width: thin;
}

.welcome-dialog-wrapper {
  background-image: url("../images/bg_welcome.png");
  background-repeat: no-repeat;
}

#public_desktop_navlink:hover {
  font-weight: 600 !important;
}

#public_desktop_navlink::after {
  display: block;
  content: attr(title);
  font-weight: 600;
  height: 1px;
  color: transparent;
  overflow: hidden;
  visibility: hidden;
}
`, "",{"version":3,"sources":["webpack://./src/styles/layout.css"],"names":[],"mappings":"AAAA;;EAEE,SAAS;EACT,UAAU;EACV,YAAY;AACd;;AAEA;EACE,aAAa;EACb,oBAAoB;AACtB;;AAEA;EACE,aAAa;EACb,oBAAoB;EACpB,WAAW;AACb;;AAEA;EACE,aAAa;EACb,WAAW;AACb;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,oBAAoB;EACpB,WAAW;EACX,YAAY;AACd;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,yBAAyB;EACzB,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,WAAW;EACX,mBAAmB;EACnB,yBAAyB;AAC3B;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,iDAAiD;EACjD,4BAA4B;AAC9B;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,cAAc;EACd,oBAAoB;EACpB,gBAAgB;EAChB,WAAW;EACX,kBAAkB;EAClB,gBAAgB;EAChB,kBAAkB;AACpB","sourcesContent":["html,\nbody {\n  margin: 0;\n  padding: 0;\n  height: 100%;\n}\n\nbody {\n  display: flex;\n  align-items: stretch;\n}\n\n#root {\n  display: flex;\n  align-items: stretch;\n  width: 100%;\n}\n\n#page {\n  display: flex;\n  width: 100%;\n}\n\n#content-wrapper {\n  display: flex;\n  flex-direction: column;\n  align-items: stretch;\n  width: 100%;\n  height: auto;\n}\n\n#content {\n  width: 100%;\n  padding: 0px;\n  height: calc(100% - 48px);\n  /*margin: 0 20px ;*/\n}\n\n#footer {\n  position: absolute;\n  bottom: 0;\n  width: 100%;\n  /* height: 100px; */\n  /* Height of the footer */\n}\n\n.swal2-container {\n  z-index: 1460 !important;\n}\n\nbody.swal2-height-auto {\n  height: 100% !important;\n}\n\n#desktop-tabpanel {\n  scrollbar-width: thin;\n}\n\n#mobile-tabpanel {\n  scrollbar-width: thin;\n}\n\n#weather-chart {\n  scrollbar-width: thin;\n}\n\n.welcome-dialog-wrapper {\n  background-image: url(\"../images/bg_welcome.png\");\n  background-repeat: no-repeat;\n}\n\n#public_desktop_navlink:hover {\n  font-weight: 600 !important;\n}\n\n#public_desktop_navlink::after {\n  display: block;\n  content: attr(title);\n  font-weight: 600;\n  height: 1px;\n  color: transparent;\n  overflow: hidden;\n  visibility: hidden;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
